import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Grid,
  GridItem,
  VStack,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  CalendarIcon,
  LockIcon,
  ChatIcon,
  ViewIcon,
  BellIcon,
  SettingsIcon,
} from '@chakra-ui/icons';

const features = [
  {
    title: 'Smart Booking System',
    description: 'Simplify the booking process with our intuitive calendar and scheduling system.',
    icon: CalendarIcon,
  },
  {
    title: 'Online Payments',
    description: 'Accept payments seamlessly through our secure payment gateway.',
    icon: LockIcon,
  },
  {
    title: 'Member Management',
    description: 'Efficiently manage memberships and track customer data.',
    icon: ChatIcon,
  },
  {
    title: 'Analytics & Reporting',
    description: 'Make data-driven decisions with comprehensive reporting tools.',
    icon: ViewIcon,
  },
  {
    title: 'Automated Notifications',
    description: 'Keep members informed with automated SMS and email notifications.',
    icon: BellIcon,
  },
  {
    title: 'Central Dashboard',
    description: 'Manage everything from one comprehensive dashboard.',
    icon: SettingsIcon,
  },
];

const FeatureCard = ({ title, description, icon: IconComponent }) => {
  return (
    <Box
      p={6}
      bg="#110F14"
      borderRadius="xl"
      transition="all 0.3s"
      _hover={{
        transform: 'translateY(-5px)',
        boxShadow: 'xl',
        bg: '#1A1824',
      }}
      height="100%"
    >
      <VStack spacing={4} align="center">
        <Icon as={IconComponent} w={8} h={8} color="#82ca9c" />
        <Heading size="md" color="white">
          {title}
        </Heading>
        <Text textAlign="center" color="gray.400">
          {description}
        </Text>
      </VStack>
    </Box>
  );
};

const FeaturesSection = () => {
  return (
    <Box py={20} bg="white">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center" maxW="800px">
            <Heading as="h2" size="2xl" color="gray.800">
              Powerful Features for Your Business
            </Heading>
            <Text fontSize="xl" color="gray.600">
            Everything you need to manage your sports facility efficiently
            </Text>
          </VStack>
          
          <Grid
            templateColumns={{
              base: "1fr",
              md: "repeat(2, 1fr)",
              lg: "repeat(3, 1fr)",
            }}
            gap={8}
            w="100%"
          >
            {features.map((feature, index) => (
              <GridItem key={index}>
                <FeatureCard {...feature} />
              </GridItem>
            ))}
          </Grid>
        </VStack>
      </Container>
    </Box>
  );
};

export default FeaturesSection; 